import { apiDelete, apiGet, apiPost } from '../api-client.ts';

export interface RangeStatistiche {
  cassa: string;
  periodoInizio: string;
  periodoFine: string;
  periodi: string[];
  nPeriodi: number;
  periodiDisponibili: string[];
  periodoMinDisponibile: string;
  periodoMaxDisponibile: string;
}

export interface RangeResult {
  range: RangeStatistiche | null;
}

export interface StatisticheResult extends RangeStatistiche {
  nomeTabella: string;
  latestPeriodo: string;
  latestSnapshot: Array<{
    sigla: string;
    nome: string;
    color: string;
    count: number;
  }>;
  totaleLatest: number;
  maxCount: number;
  fromCache: boolean;
}

export interface SeriePunto {
  periodo: string;
  count: number;
}

export interface SerieStatistica {
  sigla: string;
  nome: string;
  color: string;
  punti: SeriePunto[];
}

export const statisticheApi = {
  range: (cassa: string) =>
    apiGet<RangeResult>(`statistiche/range?cassa=${cassa}`),

  calcola: (cassa: string, periodoInizio?: string, periodoFine?: string) =>
    apiPost<StatisticheResult>('statistiche', {
      cassa,
      ...(periodoInizio !== undefined ? { periodoInizio } : {}),
      ...(periodoFine !== undefined ? { periodoFine } : {}),
    }),

  reset: (nomeTabella: string) =>
    apiDelete<{ ok: boolean }>(`statistiche/${encodeURIComponent(nomeTabella)}`),

  serie: (nomeTabella: string) =>
    apiGet<{
      nomeTabella: string;
      periodi: string[];
      serie: SerieStatistica[];
      latestPeriodo: string;
      latestSnapshot: StatisticheResult['latestSnapshot'];
      maxCount: number;
    }>(`statistiche/${encodeURIComponent(nomeTabella)}/serie`),
};
